import React from 'react';
import { func, object, shape, string } from 'prop-types';

import CSS from './styles.scss';

const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

const InteractiveCircleViews = props => {
  let {
    className,
    dispatch,
    handleOnClick,
    marker,
    outerRingFill='#142A35',
    selectedHighlight,
    type,
    xFill='#000000',
  } = props;
  let isFocused = 'false';

  const keyListen = event => {
    const { keyCode } = event;
    if (keyCode === keys.tab || keyCode === keys.esc || keyCode === keys.right || keyCode === keys.left) {
      console.log(keyCode);
      dispatch(event);
    }

    if (keyCode === keys.enter || keyCode === keys.space) {
      handleOnClick(event);
    }
  };

  if (marker.id === selectedHighlight.markerId) {
    isFocused = 'true';
  }

  if (type === 'menu') {
    if (selectedHighlight.id && marker.markerId !== selectedHighlight.markerId) {
      outerRingFill = '#FFFFFF';
    }
  }

  return (
    <div onMouseEnter={ dispatch } onMouseLeave={ dispatch } className={ className }>
      <input id={ marker.id } className={ CSS['input'] } type="radio" aria-label="marker"
        name="marker"
        value={ marker.id }
        checked={ marker.id === selectedHighlight.markerId }
        onChange={ handleOnClick }
        tabIndex="-1"/>

      <svg xmlns="http://www.w3.org/2000/svg"
        name="svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        onClickCapture={ handleOnClick }
        onKeyUp={ keyListen }
        tabIndex="0">

        <circle cx="12" cy="12" r="11" fill="none" />
        <circle cx="12" cy="12" r="11" fill={ outerRingFill } />
        <circle cx="12" cy="12" r="9" fill={ marker.color } />

        {selectedHighlight.id && (marker.id === selectedHighlight.markerId)
          ? <polygon
              fill={ xFill }
              points="19.82 5.59 18.41 4.18 12 10.59 5.59 4.18 4.18 5.59 10.59 12 4.18 18.41 5.59 19.82 12 13.41 18.41 19.82 19.82 18.41 13.41 12 19.82 5.59"
              transform="scale(0.8) translate(3,3)" />
          : null
        }
      </svg>
    </div>
  );
}

InteractiveCircleViews.propTypes = {
  className: string,
  dispatch: func,
  handleOnClick: func.isRequired,
  marker: object,
  outerRingFill: string,
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    syncId: string
  }),
  type: string,
  xFill: string
};


export default InteractiveCircleViews;
